export default __webpack_public_path__ + "static/media/logo.60ca46ae.png";